/*
 **	OMNI_IQ Mobile API Configuration (c) 2025 Silver Falls Capital. All Rights Reserved
 **
 **	Author(s): Claude Code Assistant
 **
 */

import { Configuration } from '@silverfallscapital/strata47-typescript-sdk'
import type { HTTPHeaders } from '@silverfallscapital/strata47-typescript-sdk'
import Config from './config'

export type auth0TokenType = "auth0"
export type strata47TokenType = "strata47"
export type tokenTypes = auth0TokenType | strata47TokenType

const headers: HTTPHeaders = {
  "x-bp-token": Config.STRATA47_BP_TOKEN,
  "X-Client-Type": "omniiq-mobile-client",
}

export function tokenType(token: string): tokenTypes {
  // check if the token is prepended with "auth0|" or
  // other providers
  if (token.startsWith("auth0|")) {
    return "auth0"
  } else {
    return "strata47"
  }
}

function auth0Configuration(token: string): Configuration {
  const tokenParts = token.split("|")
  const tokenValue = tokenParts[1]
  return new Configuration({
    basePath: Config.STRATA47_API_URL,
    headers: { ...headers, Authorization: `Bearer ${tokenValue}` },
    accessToken: tokenValue, // Also set accessToken for SDK compatibility
  })
}

function strata47Configuration(token: string): Configuration {
  const tokenValue = token.replace("strata47|", "")
  return new Configuration({
    basePath: Config.STRATA47_API_URL,
    headers: { ...headers, Authorization: `Bearer ${tokenValue}` },
    accessToken: tokenValue, // Also set accessToken for SDK compatibility
  })
}

export function apiTokenConfiguration(token: string): Configuration {
  const type = tokenType(token)
  switch (type) {
    case "auth0":
      return auth0Configuration(token)
    case "strata47":
      return strata47Configuration(token)
  }
}

export function apiLoginConfiguration(): Configuration {
  return new Configuration({
    basePath: Config.STRATA47_API_URL,
    headers: headers,
  })
}